<script lang="ts" setup>
import { i18n } from '@/i18n';
import { ResizeStateService } from '../services/resizeStateService';

// props
const props = withDefaults(
  defineProps<{
    index: number;
    label?: string;
    textAlign?: string; // スロットに要素を渡す場合は、そちらに設定して投げてください
    resizable?: boolean;
    toolTipValue?: string;
  }>(),
  {
    label: '',
    textAlign: 'center',
    resizable: false,
    toolTipValue: '',
  }
);

// emits
const emits = defineEmits<{
  (e: 'onHover'): void;
  (e: 'onLeave'): void;
  (e: 'onClick'): void;
  (e: 'onMousedownResizer', event: MouseEvent): void;
}>();

//変数
const t = i18n.t;
</script>

<template>
  <th
    :id="ResizeStateService.getTableHeaderId(index)"
    v-tooltip.bottom="props.toolTipValue"
    class="header-cell"
    @mouseover="emits('onHover')"
    @mouseleave="emits('onLeave')"
    @click="emits('onClick')"
  >
    <template v-if="props.label">
      <div class="header-cell__content">
        <div class="table__header-cell--text">{{ t(props.label) }}</div>
        <slot />
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
    <div v-if="resizable" class="resizer__container">
      <div class="resizer__item" @mousedown="emits('onMousedownResizer', $event)" />
    </div>
  </th>
</template>

<style lang="scss" scoped>
.header-cell {
  height: 36px;
  background-color: $surfaceSecondary;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 16px;
  position: relative;
  z-index: 0;
  text-align: v-bind(textAlign);

  color: $textDefault;
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0;

  &__content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}

.resizer {
  &__container {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 6px;
    z-index: 5;
    cursor: col-resize;

    &::after {
      content: '';
      position: absolute;
      right: 2px;
      top: 25%;
      bottom: 25%;
      width: 2px;
      border-radius: 1px;
      background-color: $borderSecondary;
      transition: background-color 0.15s ease;
    }

    &:hover::after {
      background-color: $borderActive;
    }
  }

  &__item {
    height: 100%;
    width: 100%;
    cursor: col-resize;
  }
}
</style>
